import React from 'react';
import { Box, Button, Paper, Rating, Stack, TextField, Typography } from '@mui/material';

interface PostTradeReviewPanelProps {
  reviewTargetDisplayName: string;
  reviewTargetUserId: string;
  reviewAssignment: any;
  reviewRating: number | null;
  reviewComment: string;
  submitting: boolean;
  canSubmit: boolean;
  onRatingChange: (value: number | null) => void;
  onCommentChange: (value: string) => void;
  onSubmit: () => void;
  onViewProfile: () => void;
}

const PostTradeReviewPanel: React.FC<PostTradeReviewPanelProps> = ({
  reviewTargetDisplayName,
  reviewTargetUserId,
  reviewAssignment,
  reviewRating,
  reviewComment,
  submitting,
  canSubmit,
  onRatingChange,
  onCommentChange,
  onSubmit,
  onViewProfile,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Review your trade counterpart
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Leave a quick 5-star review for the person you were supposed to receive an item from.
        </Typography>
        {!!(reviewTargetDisplayName || reviewTargetUserId) && (
          <Typography variant="body2" color="text.secondary">
            Trade counterpart: <strong>{reviewTargetDisplayName || reviewTargetUserId}</strong>
          </Typography>
        )}
        {(reviewAssignment?.receiveItem || reviewAssignment?.giveItem) && (
          <Typography variant="body2" color="text.secondary">
            Expected receive item: {reviewAssignment?.receiveItem || 'Unknown'}  Your item given: {reviewAssignment?.giveItem || 'Unknown'}
          </Typography>
        )}
        {reviewTargetUserId && (
          <Box>
            <Button variant="text" onClick={onViewProfile}>
              View Trader Profile
            </Button>
          </Box>
        )}
        <Box>
          <Typography variant="body2" color="text.secondary">Rating</Typography>
          <Rating value={reviewRating} onChange={(_, value) => onRatingChange(value)} />
        </Box>
        <TextField label="Comment (optional)" value={reviewComment} onChange={(e) => onCommentChange(e.target.value)} multiline minRows={3} />
        <Button variant="contained" onClick={onSubmit} disabled={submitting || !canSubmit}>Submit Review</Button>
      </Stack>
    </Paper>
  );
};

export default PostTradeReviewPanel;
